var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgTotalIncome = function SvgTotalIncome(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.949,
    height: 21,
    viewBox: "0 0 20.949 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69875",
    "data-name": "Group 69875",
    transform: "translate(-2.999 -1.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34263",
    "data-name": "Path 34263",
    d: "M11.353,6.961a.728.728,0,0,1,.784.654h1.569a2.021,2.021,0,0,0-1.569-1.841V5H10.569v.774A1.946,1.946,0,0,0,9.035,7.951a2.269,2.269,0,0,0,2.318,1.625.728.728,0,0,1,.784.654.728.728,0,0,1-.784.654.728.728,0,0,1-.784-.654H9a2.021,2.021,0,0,0,1.569,1.841v.774h1.569V12.07a1.946,1.946,0,0,0,1.534-2.177,2.269,2.269,0,0,0-2.318-1.625.728.728,0,0,1-.784-.654A.728.728,0,0,1,11.353,6.961Z",
    transform: "translate(-1.294 -0.35)",
    fill: "#ffd45d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34264",
    "data-name": "Path 34264",
    d: "M17.119,8.744a6.819,6.819,0,0,0-5.473-6.582A7.163,7.163,0,0,0,3.71,5.788a6.553,6.553,0,0,0,1.923,8.2H5.353A2.3,2.3,0,0,0,3,16.241v.75a2.178,2.178,0,0,0,.612,1.5A2.178,2.178,0,0,0,3,19.99v.75a2.3,2.3,0,0,0,2.353,2.249h9.412a2.3,2.3,0,0,0,2.353-2.249v-.75a2.178,2.178,0,0,0-.612-1.5,2.178,2.178,0,0,0,.612-1.5v-.75a2.3,2.3,0,0,0-2.353-2.249h-.279a6.626,6.626,0,0,0,2.632-5.248Zm-1.569,12a.768.768,0,0,1-.784.75H5.353a.768.768,0,0,1-.784-.75v-.75a.768.768,0,0,1,.784-.75h9.412a.768.768,0,0,1,.784.75Zm-.784-5.248a.768.768,0,0,1,.784.75v.75a.768.768,0,0,1-.784.75H5.353a.768.768,0,0,1-.784-.75v-.75a.768.768,0,0,1,.784-.75ZM4.569,8.744A5.373,5.373,0,0,1,10.059,3.5,5.373,5.373,0,0,1,15.55,8.744a5.373,5.373,0,0,1-5.491,5.248A5.38,5.38,0,0,1,4.569,8.744Z",
    transform: "translate(0 0)",
    fill: "#8d8db5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69874",
    "data-name": "Group 69874",
    transform: "translate(18.133 1.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34265",
    "data-name": "Path 34265",
    d: "M24.646,12.23l-2.353,2.353L23.4,15.692l1.014-1.014v5.95h1.569v-5.95L27,15.692l1.109-1.109L25.755,12.23a.784.784,0,0,0-1.109,0Z",
    transform: "translate(-22.293 -4.728)",
    fill: "#8d8db5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34266",
    "data-name": "Path 34266",
    d: "M24.646,7.23,22.293,9.583,23.4,10.692l1.8-1.8,1.8,1.8,1.109-1.109L25.755,7.23a.784.784,0,0,0-1.109,0Z",
    transform: "translate(-22.293 -3.287)",
    fill: "#ffd45d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34267",
    "data-name": "Path 34267",
    d: "M25.2,3.894l1.8,1.8,1.109-1.109L25.755,2.23a.784.784,0,0,0-1.109,0L22.293,4.583,23.4,5.692Z",
    transform: "translate(-22.293 -2)",
    fill: "#ffd45d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34268",
    "data-name": "Path 34268",
    d: "M23,25h4.706v1.569H23Z",
    transform: "translate(-22.445 -7.931)",
    fill: "#8d8db5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34269",
    "data-name": "Path 34269",
    d: "M23,28h4.706v1.569H23Z",
    transform: "translate(-22.445 -8.578)",
    fill: "#8d8db5"
  })))));
};

export default SvgTotalIncome;